import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-18 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-3">
            分类浏览
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
            按题材发现好漫画
          </h2>
          <p className="text-foreground-600 text-sm max-w-lg mx-auto">
            八大分类，覆盖所有热门韩漫类型，点击进入你的兴趣领域
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 bg-background-100 hover:bg-background-200 rounded-xl transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-3 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-lg md:text-xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-1">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs leading-relaxed">
                {cat.desc}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}